var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoupon = function SvgCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.825 21.325L0 10.5V0.5H10L20.8 11.35L10.825 21.325ZM10.825 18.5L17.975 11.35L9.15 2.5H2V9.65L10.825 18.5ZM4.5 6.5C4.91667 6.5 5.27067 6.354 5.562 6.062C5.854 5.77067 6 5.41667 6 5C6 4.58333 5.854 4.22933 5.562 3.938C5.27067 3.646 4.91667 3.5 4.5 3.5C4.08333 3.5 3.72933 3.646 3.438 3.938C3.146 4.22933 3 4.58333 3 5C3 5.41667 3.146 5.77067 3.438 6.062C3.72933 6.354 4.08333 6.5 4.5 6.5Z",
    fill: "#000"
  })));
};
export default SvgCoupon;